import { createStore } from 'zustand/vanilla';
import { CalcModel, CarWithCalculation } from '../types';

export type FleetCalculatorState = {
  allCarModels: CalcModel[];
  activeCarPair: CarWithCalculation[];
  activeTrimCodes: string[];
  selectableTrimCodes: string[];

  isCompactLayout: boolean;
  isSwitchCarModalOpen: boolean;
  carIndexToReplace: number | null;
  isFilterModalOpen: boolean;
  detailedCarViewData: CarWithCalculation | null;
};

export type FleetCalculatorActions = {
  updateState: (state: Partial<FleetCalculatorState>) => void;

  initializeTrims: (activeTrims: string[], availableTrims: string[]) => void;
  replaceActiveCar: (index: number, newTrimCode: string) => void;

  openSwitchCarModal: (index: number) => void;
  closeSwitchCarModal: () => void;
  openCarDetailsModal: (car: CarWithCalculation) => void;
  closeCarDetailsModal: () => void;
};

export type FleetCalculatorStore = FleetCalculatorState &
  FleetCalculatorActions;

export const createFleetCalculatorStore = (
  initialState: Partial<FleetCalculatorState> = {},
) => {
  return createStore<FleetCalculatorStore>()((set) => ({
    allCarModels: [],
    activeCarPair: [],
    activeTrimCodes: [],
    selectableTrimCodes: [],
    isCompactLayout: false,
    isSwitchCarModalOpen: false,
    carIndexToReplace: null,
    isFilterModalOpen: false,
    detailedCarViewData: null,
    ...initialState,

    updateState: (state) => set(state),

    initializeTrims: (activeTrims, availableTrims) =>
      set({
        activeTrimCodes: activeTrims,
        selectableTrimCodes: availableTrims,
      }),

    replaceActiveCar: (index, newTrimCode) =>
      set((state) => {
        if (index < 0 || index >= state.activeTrimCodes.length) return {};
        const newActiveTrimCodes = [...state.activeTrimCodes];
        newActiveTrimCodes[index] = newTrimCode;
        return { activeTrimCodes: newActiveTrimCodes };
      }),

    openSwitchCarModal: (index) =>
      set({ carIndexToReplace: index, isSwitchCarModalOpen: true }),

    closeSwitchCarModal: () =>
      set({ carIndexToReplace: null, isSwitchCarModalOpen: false }),

    openCarDetailsModal: (car) => set({ detailedCarViewData: car }),

    closeCarDetailsModal: () => set({ detailedCarViewData: null }),
  }));
};
